<template>
  <section class="section-cover full row">
    <div class="section-title pad col-5">
      <h2 class="title">
        <slot> </slot>
      </h2>
    </div>
    <div class="cover-image col-5">
      <img :src="getImageOrientation(img)" />
      <div class="next-arrow" v-if="nextArrow" @click="$scroll.next()">
        <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'enter-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M14.684 20.776l6.123-4.936-6.123-4.944" stroke="#fff" stroke-width="1.5" stroke-miterlimit="10"/><path d="M16.745 30.836c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15z" stroke="#fff" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/></svg>
      </div>
    </div>
  </section>
</template>

<script>
import imageMixin from '@/plugins/image-mixin';

export default {
  name: 'SectionCover',
  mixins: [imageMixin],
  props: {
    img: {
      type: [String, Object],
      default: null
    },
    nextArrow: Boolean
  }
};
</script>

<style lang="scss" scoped>
.section-cover {
  .section-title {
    background-color: $col-blue-light;
    color: white;
    @include centered(false, true, column);
    span {
      display: inline;
    }
  }
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .cover-image {
    position: relative;
    .next-arrow {
      position: absolute;
      bottom: 1rem;
      left: 0;
      width: 100%;
      display: flex;
      justify-content: center;
      animation: bounce 1s infinite;
      svg {
        cursor: pointer;
        transform: rotate(90deg);
      }
    }
  }
}
</style>
